(function () {
  const SECTION_SELECTOR = '[data-gb-combo-offers]';
  const instances = new WeakMap();

  class ComboOffers {
    constructor(root) {
      this.root = root;
      this.toast = root.querySelector('[data-combo-toast]');
      this.hideToastTimer = 0;
      this.enableCartDrawer = root.dataset.enableCartDrawer === 'true';
      this.onClick = this.onClick.bind(this);
      this.onVariantChange = this.onVariantChange.bind(this);
    }

    init() {
      this.root.addEventListener('click', this.onClick);
      this.root.addEventListener('change', this.onVariantChange);
    }

    destroy() {
      this.root.removeEventListener('click', this.onClick);
      this.root.removeEventListener('change', this.onVariantChange);
      window.clearTimeout(this.hideToastTimer);
    }

    onVariantChange(event) {
      const select = event.target.closest('[data-variant-select]');
      if (!(select instanceof HTMLSelectElement)) return;

      const card = select.closest('.gb-combo-offers__card');
      if (!card) return;

      const selectedOption = select.options[select.selectedIndex];
      const priceNode = card.querySelector('[data-price]');
      const compareNode = card.querySelector('[data-compare]');

      if (priceNode && selectedOption.dataset.price) {
        priceNode.textContent = selectedOption.dataset.price;
      }

      if (compareNode) {
        const compareText = selectedOption.dataset.compare || '';
        compareNode.textContent = compareText;
        compareNode.hidden = !compareText;
      }

      const addButton = card.querySelector('[data-add-to-cart]');
      if (addButton instanceof HTMLButtonElement) {
        addButton.dataset.defaultVariantId = select.value;
        addButton.disabled = selectedOption.disabled;
      }
    }

    onClick(event) {
      const button = event.target.closest('[data-add-to-cart]');
      if (!(button instanceof HTMLButtonElement)) return;
      event.preventDefault();
      if (button.disabled) return;
      this.handleAddToCart(button);
    }

    getVariantId(button) {
      const card = button.closest('.gb-combo-offers__card');
      const select = card?.querySelector('[data-variant-select]');
      if (select instanceof HTMLSelectElement && select.value) {
        return parseInt(select.value, 10);
      }
      return parseInt(button.dataset.defaultVariantId || '', 10);
    }

    async handleAddToCart(button) {
      const variantId = this.getVariantId(button);
      if (!variantId) {
        this.showToast('Unable to add this product.');
        return;
      }

      const prevDisabled = button.disabled;
      button.disabled = true;

      try {
        const response = await fetch('/cart/add.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            Accept: 'application/json',
          },
          body: JSON.stringify({
            id: variantId,
            quantity: 1,
          }),
        });

        if (!response.ok) {
          throw new Error('cart_add_failed');
        }

        document.dispatchEvent(new CustomEvent('cart:refresh'));
        document.dispatchEvent(new CustomEvent('cart:updated'));

        const opened = this.enableCartDrawer ? this.tryOpenCartDrawer() : false;
        if (!opened) {
          this.showToast('Added to cart');
        }
      } catch (error) {
        this.showToast('Could not add to cart');
      } finally {
        button.disabled = prevDisabled;
      }
    }

    tryOpenCartDrawer() {
      const drawerSelectors = [
        'cart-drawer',
        '[data-cart-drawer]',
        '.cart-drawer',
        '#CartDrawer',
        '.drawer--cart',
        'cart-notification',
      ];

      for (const selector of drawerSelectors) {
        const drawer = document.querySelector(selector);
        if (!drawer) continue;

        if (typeof drawer.open === 'function') {
          drawer.open();
          return true;
        }

        drawer.setAttribute('open', 'true');
        drawer.classList.add('is-open', 'active');
        return true;
      }

      document.dispatchEvent(new CustomEvent('cart:open'));
      window.dispatchEvent(new CustomEvent('cart:open'));
      document.documentElement.dispatchEvent(new CustomEvent('cart:open'));

      return false;
    }

    showToast(message) {
      if (!this.toast) return;

      this.toast.textContent = message;
      this.toast.classList.add('is-visible');
      window.clearTimeout(this.hideToastTimer);
      this.hideToastTimer = window.setTimeout(() => {
        this.toast?.classList.remove('is-visible');
      }, 1900);
    }
  }

  function init(scope) {
    const root = scope || document;
    root.querySelectorAll(SECTION_SELECTOR).forEach((section) => {
      if (instances.has(section)) return;
      const app = new ComboOffers(section);
      app.init();
      instances.set(section, app);
    });
  }

  function unload(event) {
    const section = event.target.querySelector(SECTION_SELECTOR);
    if (!section) return;
    const app = instances.get(section);
    if (!app) return;
    app.destroy();
    instances.delete(section);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => init(document), { once: true });
  } else {
    init(document);
  }

  document.addEventListener('shopify:section:load', (event) => init(event.target));
  document.addEventListener('shopify:section:unload', unload);
})();
